module.exports = __webpack_public_path__ + "img/icon_kefu.944361de.png";